import Swiper from 'swiper';
import { Navigation, EffectFade, A11y } from 'swiper/modules';
import Rotate360 from './Rotate360';
import TabList from '../TabList';
import { isDesktop, isLandScape, isTablet } from '../../utils';
import ColorSelection, { brightCheckedClass, checkImageBrightness, setPositionColorName } from '../../components/ColorSelection';
import CallBackLazy from '../../components/CallBackLazy';
import ADA from '../../components/ADA';
import { USER_INTERACTION_EVENTS } from '../../constants';

export default class ModTrimBannerHero {
  constructor(el) {
    this.$el = $(el);
    this.text = {
      dataColor: 'data-color',
      marginTop: 'margin-top',
      ariaHidden: 'aria-hidden',
    };
    this.classes = {
      hiddenScroll: 'hidden-scroll',
      scrollAni: 'scroll-ani',
      hidden: 'hidden',
      changeSlide: 'change-slide',
      active: 'active',
      zoom: 'on-zoom',
      showContent: 'show-content',
      hidePrev: 'hide-prev',
      start360Scroll: 'start-360-scroll',
      done360Scroll: 'done-360-scroll',
      showMainBanner: 'show-main-banner',
      firstTabActive: 'first-tab-active',
      showScroll: 'show-scroll',
    };
    this.elementClasses = {
      colorButton: '.js-color-button',
      colorItemTab: '.color-main-item',
      screenColors: '.trim-screen-colors',
      listDisclaimer: '.list-disclaimer',
      bgColor: '.js-color-bg',
      fakeColor: '.fake-color-trim',
      trimSliderNav: '.trims-slider-nav',
      parentClass: '.button-color-view360, .button-color-interior-view, .button-color-rider-view, .button-color-top-view',
      jsColorRadio: '.js-color-radio',
    };
    this.dom = {
      $wrapper: this.$el.find('.trim-banner-hero-wrapper'),
      $bodyHtml: $('html'),
      $body: $('body'),
      $mainContent: $('.main-content'),
      $scroll360Items: this.$el.find('.image-360'),
      $overplay: this.$el.find('.overplay-360'),
      $rotate360: this.$el.find('.gallery-360'),
      $content360: this.$el.find('.scroll-360-content'),
      $marzipano: this.$el.find('.img-marzipano'),
      $locoScrollMain: $('.locomotive-scroll'),
      $btnColor: this.$el.find(this.elementClasses.colorButton),
      $tabs: this.$el.find('.trim-banner-tab'),
      $tab: this.$el.find('[role="tabpanel"]'),
      $btnZoom: this.$el.find('.btn-zoom'),
      $subNav: $('.mod-sub-navigation'),
      $image360: this.$el.find('.lazy-360-scroll'),
      $staticBannerHero: this.$el.find('.text-static-banner-hero'),
      $scrollBannerHero: this.$el.find('.text-scroll-banner-hero'),
      $btnTabView: this.$el.find('.btn-tab-view'),
    };
    this.lazyLoad = new CallBackLazy();
    this.hasScroll360 = this.dom.$scroll360Items.length;
    this.rotate360s = [];
    this.marzipanoTalon = [];
    this.windowScroll = 0;
    this.startPin = 0;
    this.pinWidthTimBanner = 0;
    this.startScroll360 = parseInt(this.$el.attr('data-start-360'), 10) || 0;
    this.scrollWidthPerScreen360 = isDesktop() ? (parseInt(this.$el.attr('data-per-screen'), 10) || 100) : (parseInt(this.$el.attr('data-per-screen-mobile'), 10) || 75);
    this.scrollWidthAfterScroll360 = parseInt(this.$el.attr('data-after-360'), 10) || 0;
    this.scrollWidthPin360 = this.startScroll360 + this.scrollWidthPerScreen360 * this.dom.$scroll360Items.length + this.scrollWidthAfterScroll360;
    this.scrollWidthPin = this.hasScroll360 ? this.scrollWidthPin360 : 100;
    this.winScrollTop = 0;
    this.colorId = this.$el.find(this.elementClasses.screenColors).eq(0).find(`.${this.classes.active}`).attr(this.text.dataColor);
    this.marzipanoTalonCurrentParameters = null;
    this.heightSubMenu = 0;
    this.windowWidth = $(window).width();
    this.loaded = false;
    this.positionFlag = 0;
    this.flagSlide = 0;
    this.flagScroll = false;
    window.scrollWidthPin = this.scrollWidthPin;
    this.listSwiper = [];
    this.adaInstance = new ADA();
    this.init();
  }

  init() {
    this.dom.$bodyHtml.addClass('has-trim-banner-hero');
    this.dom.$body.addClass(this.classes.firstTabActive);
    if (!this.dom.$tabs.length) {
      this.$el.addClass('no-tabs');
    }
    if (!this.hasScroll360) {
      this.$el.addClass('no-scroll360');
    }
    this.addCarousel();
    this.setHeight();
    this.addListeners();
    this.scrollActive();
    this.intRotate360();
    this.initMarzipano();
    this.runTabsList();
    this.load360Image();
    this.changeColorModel();
    this.start360Scroll();
    this.checkHiddenTextBanner();
    this.checkFillSvg();
    this.setPositionForColorName();
    this.checkBrightnessColor();
    this.touchMovedMobile();
  }

  checkFillSvg() {
    const fillColor = this.$el.find('.tablist').attr('data-fill');
    const $path = this.$el.find('svg path');
    $path.attr('fill', fillColor);
    $path.each((_index, el) => {
      const $el = $(el);
      const fill = $el.attr('stroke');
      if (fill) {
        $el.attr('stroke', fillColor);
      }
    });
  }

  addCarousel() {
    const $gallery = this.$el.find('.gallery-trim');
    $gallery.css({'display': 'block', 'opacity': 0});
    $gallery.each((_index, el) => {
      const $itemList = $(el).find('.slider-trims');
      if ($itemList.find('.swiper-slide').length < 2) {
        $(el).find(this.elementClasses.trimSliderNav).addClass('hidden');
      }
      const swiper = new Swiper($itemList[0], {
        modules: [Navigation, EffectFade, A11y],
        speed: 500,
        effect: 'fade',
        allowTouchMove: false,
        rewind: true,
        navigation: {
          nextEl: $(el).find('.swiper-button-next')[0],
          prevEl: $(el).find('.swiper-button-prev')[0],
        },
      });
      swiper.on('slideChange', (e) => {
        $(this.elementClasses.trimSliderNav).each((_indexm, elm) => {
          const lengthSlide = $(elm).parents('.gallery-trim').find('.swiper-slide').length;
          if (e.activeIndex + 1 <= lengthSlide) {
            $(elm).find('.current-slide').text(e.activeIndex + 1);
          }
        });

        if (e.activeIndex === 0) {
          this.dom.$body.removeClass(this.classes.changeSlide);
          if ($('.js-color-radio.active').length === 0) {
            this.dom.$body.addClass(this.classes.firstTabActive);
          }
        } else {
          this.dom.$body.addClass(this.classes.changeSlide);
          this.dom.$body.removeClass(this.classes.firstTabActive);
        }
        this.listSwiper.forEach((item) => {
          item.slideTo(e.activeIndex);
        });
        this.adaInstance.removeAttrAriaDisabled(this.$el);
      });
      setTimeout(() => {
        $gallery.css({'display': '', 'opacity': ''});
      }, 100);
      this.listSwiper.push(swiper);
      this.adaInstance.removeAttrAriaDisabled(this.$el);
    });
  }

  touchMovedMobile() {
    setTimeout(() => {
      if ($(window).scrollTop() > 100) {
        this.dom.$bodyHtml.addClass(this.classes.showScroll);
      }
    }, 1000);
    $(window).on('touchmove', (event) => {
      if ($(window).innerWidth() < 1200) {
        const currentTouchY = event.originalEvent.touches[0].clientY;
        if (currentTouchY < this.lastTouchY && $(window).scrollTop() < 16 && !this.$el.hasClass('no-scroll-ani') && !this.dom.$bodyHtml.hasClass(this.classes.showScroll)) {
          this.$el.addClass(this.classes.scrollAni);
          setTimeout(() => {
            this.dom.$bodyHtml.addClass(this.classes.showScroll);
            $(window).scrollTop(17);
            this.dom.$body.addClass('wheel-down').removeClass('wheel-up');
            $('#header').addClass('hide-header');
          }, 500);
        }
        this.lastTouchY = currentTouchY;
      }
    });
  }

  load360Image() {
    if (this.dom.$image360.length) {
      $(document).ready(() => {
        this.dom.$image360.each((_index, element) => {
          const elementTmp = element.tagName;
          this.lazyLoad.call(elementTmp, element);
        });
      });
    }
  }

  addListeners() {
    window.scrollAgent.scrollEvent((args) => {
      const scrollY = parseFloat(args.scroll.y.toFixed(2));
      if (isDesktop() && (this.positionFlag !== scrollY)) {
        this.positionFlag = scrollY;
        this.winScrollTop = scrollY;
        this.actionScroll();
        if (this.winScrollTop > 50 && !this.flagScroll && this.dom.$body.hasClass(this.classes.firstTabActive)) {
          const urlObj = new URL(window.location.href);
          const hashPart = urlObj.hash;
          if (!hashPart.length > 0) {
            window.scrollAgent.$scrollEvent.stop();
            setTimeout(() => {
              window.scrollAgent.$scrollEvent.scrollTo(50, { duration: 0 });
            }, 0);
            this.flagScroll = true;
            setTimeout(() => {
              window.scrollAgent.$scrollEvent.start();
            }, 1000);
          }
        }
        if (this.winScrollTop < 50) {
          this.flagScroll = false;
        }
      }
    });
    $(window).on('resize', () => {
      if (!isDesktop()) {
        this.winScrollTop = $(window).scrollTop();
      }
      this.checkHiddenTextBanner();
      this.actionScroll();
      // update position for color name when resize
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.setPositionForColorName();
      }, 200);
    });
    $(window).on('scroll', () => {
      if (!isDesktop()) {
        this.winScrollTop = $(window).scrollTop();
        this.actionScroll();
      }
    });
    this.dom.$btnColor.on('click', (e) => {
      const $el = $(e.currentTarget);
      const oldColorId = this.colorId;
      this.colorId = $el.attr(this.text.dataColor);
      const $colorWrap = $(this.elementClasses.fakeColor);
      window.colorId = this.colorId;
      this.marzipanoTalonCurrentParameters = this.marzipanoTalon.find((item) => item.id === oldColorId)?.item.getCurrentScene() || null;
      this.setMarzipanoCurrentParameters();
      this.changeColorButton($el);
      this.runMarzipano();

      // update position for color name when click color
      $colorWrap.removeClass('show-color-name');
      setTimeout(() => {
        this.setPositionForColorName();
        $colorWrap.addClass('show-color-name');
      }, 100);
    });
    this.dom.$btnZoom.on('click', (e) => {
      const $el = $(e.currentTarget);
      $el.toggleClass(this.classes.zoom);
      this.$el.toggleClass(this.classes.zoom);
    });

    // update position for color name when change views
    this.dom.$btnTabView.on('click', () => {
      this.setPositionForColorName();
    });

    $(window).on(USER_INTERACTION_EVENTS, () => {
      this.checkBrightnessColor();
    });
  }

  checkHiddenTextBanner() {
    const widthTextStatic = this.dom.$staticBannerHero.find('span').width();
    if (this.$el.innerWidth() < widthTextStatic) {
      this.dom.$staticBannerHero.addClass(this.classes.hiddenScroll).attr(this.text.ariaHidden, 'true');
      this.dom.$scrollBannerHero.removeClass(this.classes.hiddenScroll).removeClass(this.classes.hidden).attr(this.text.ariaHidden, '');;
    } else {
      this.dom.$staticBannerHero.removeClass(this.classes.hiddenScroll).attr(this.text.ariaHidden, '');;
      this.dom.$scrollBannerHero.addClass(this.classes.hiddenScroll).addClass(this.classes.hidden).attr(this.text.ariaHidden, 'true');
    }
  }

  actionScroll() {
    this.scrollActive();
    this.setPinItem();
    this.start360Scroll();
    this.checkFirstTabScroll();
  }

  afterChangeTab() {
    this.dom.$btnZoom.removeClass(this.classes.zoom);
    this.$el.removeClass(this.classes.zoom);
    this.runMarzipano();
    this.$el.addClass(this.classes.showMainBanner);
    this.runRotate360();
    if (this.$el.find('.btn-tab-view.active').index() === 0) {
      this.$el.removeClass(this.classes.showMainBanner);
    }
  }

  runTabsList() {
    this.tabList = new TabList(this.dom.$tabs, this.afterChangeTab.bind(this));
    this.tabList.init();
  }

  initMarzipano() {

    if (this.dom.$marzipano.length) {
      import('./MarzipanoTalon')
        .then((module) => {
          const MarzipanoTalon = module.default;
          this.dom.$marzipano.each((_index, el) => {
            const marzipanoTalon = {
              id: $(el).attr(this.text.dataColor),
              item: new MarzipanoTalon(el),
              el,
            };
            this.marzipanoTalon.push(marzipanoTalon);
          });
        })
        .catch((error) => {
          console.error('Error importing MarzipanoTalon:', error);
        });
    }
    this.runMarzipano();
  }

  runMarzipano() {
    setTimeout(() => {
      this.marzipanoTalon.forEach((marzipanoTalon) => {
        if ($(marzipanoTalon.el).is(':visible') && this.$el.hasClass(this.classes.showMainBanner) && !marzipanoTalon.item.loaded) {
          marzipanoTalon.item.init();
        }
      });
    }, 0);
  }

  setMarzipanoCurrentParameters() {
    setTimeout(() => {
      this.marzipanoTalon.forEach((marzipanoTalon) => {
        if ($(marzipanoTalon.el).is(':visible') && this.$el.hasClass(this.classes.showMainBanner && marzipanoTalon.item.loaded) && this.marzipanoTalonCurrentParameters !== null) {
          marzipanoTalon.item.setCurrentScene(this.marzipanoTalonCurrentParameters);

        }
      });
    }, 0);
  }

  intRotate360() {
    this.dom.$rotate360.each((_index, el) => {
      const rotate360 = {
        id: $(el).attr(this.text.dataColor),
        item: new Rotate360(el),
        el,
      };
      this.rotate360s.push(rotate360);
    });
    this.runRotate360();
  }

  runRotate360() {
    setTimeout(() => {
      if (this.$el.hasClass(this.classes.showMainBanner)) {
        this.rotate360s.forEach((rotate360) => {
          if (!rotate360.item.loaded) {
            rotate360.item.init();
          }
        });
      }
    }, 0);
  }

  changeColorButton(elTarget) {
    $(this.elementClasses.colorButton).prop('checked', false);
    this.dom.$tab.each((_i, el) => {
      if ($(el).find(`[${this.text.dataColor}="${this.colorId}"]`).length) {
        $(el).find(`[${this.text.dataColor}]`).removeClass(this.classes.active);
        $(el).find(`[${this.text.dataColor}="${this.colorId}"]`).addClass(this.classes.active);
        $($(el).find(`[${this.text.dataColor}="${this.colorId}"]`)[1]).prop('checked', true);
        $(this.elementClasses.fakeColor).find(`[${this.text.dataColor}]`).removeClass(this.classes.active);
        $(this.elementClasses.fakeColor).find(`[${this.text.dataColor}="${this.colorId}"]`).addClass(this.classes.active);
        $(this.elementClasses.fakeColor).find(`[${this.text.dataColor}]`).prop('checked', false);
        $($(this.elementClasses.fakeColor).find(`[${this.text.dataColor}="${this.colorId}"]`)[0]).prop('checked', true);

        if ($(el).find(`[${this.text.dataColor}="${this.colorId}"]`).length === 1) {
          $($(el).find(this.elementClasses.bgColor)[0]).find(this.elementClasses.colorButton).addClass('active');
          $($(el).find(this.elementClasses.bgColor)[0]).find(this.elementClasses.colorButton).prop('checked', true);
        }

        const $parents = elTarget.parents(this.elementClasses.parentClass);
        this.dom.$body.removeClass(this.classes.firstTabActive);
        this.triggerGallery($parents);
        // Do something with isChecked
      }
    });
  }

  triggerGallery($parents) {
    if ($parents.length) {
      const $parent = $parents.first().closest('.trim-hero-banner-tabpanel');
      if ($parent.find(`[${this.text.dataColor}="${this.colorId}"]`).length === 1) {
        $('#trim-hero-banner-gallery').trigger('click');
      }
    };
  };

  showContent360() {
    this.dom.$content360.each((_index, el) => {
      const $el = $(el);
      const showFrom = parseInt($el.attr('data-show-from'), 10);
      const showTo = parseInt($el.attr('data-show-to'), 10) + 1;
      if (this.active360Index >= showFrom && this.active360Index < showTo) {
        const transformValue = 50 - ((this.active360Index - showFrom) / (showTo - showFrom)) * 100;
        const opacityValue = 1;
        let numberScreen = 0;
        if (isLandScape()) {
          numberScreen = 15;
        } else {
          numberScreen = 0;
        }
        $el.css({
          opacity: opacityValue,
          transform: isDesktop() ? `translateY(${transformValue - numberScreen}%)` : '',
        });
        $el.addClass(this.classes.showContent).removeClass(this.classes.hidePrev);
      } else {
        if (this.active360Index > showTo) {
          $el.css({
            opacity: 0,
            transform: isDesktop() ? 'translateY(-70%)' : '',
          });
          $el.addClass(this.classes);
        } else {
          $el.css('opacity', 0);
        }
        $el.removeClass(this.classes.showContent);
      }
    });
  }

  checkFirstTabScroll() {
    if ($('.btn-tab-view.active').index() === 0 && $('.js-color-radio.active').parent().index() === 0 && !this.dom.$body.hasClass(this.classes.changeSlide)) {
      this.dom.$body.addClass(this.classes.firstTabActive);
    }
  };

  start360Scroll() {
    if (!this.hasScroll360) {
      return;
    }

    if (this.pinWidthTimBanner > this.startScroll360) {
      this.active360Index = parseInt((this.pinWidthTimBanner - this.startScroll360) / this.scrollWidthPerScreen360, 10);
      if (this.active360Index < this.dom.$scroll360Items.length) {
        this.$el.addClass(this.classes.start360Scroll).removeClass(this.classes.showMainBanner);
        this.dom.$scroll360Items.removeClass(this.classes.active).eq(this.active360Index).addClass(this.classes.active);
      } else {
        this.$el.removeClass(this.classes.start360Scroll).addClass(this.classes.showMainBanner);
        this.runRotate360();
        this.runMarzipano();
      }
      let opacity = 1;
      if (this.active360Index <= 6) {
        opacity = Math.max(0.16, 0.16 + ((this.active360Index - 1) / 5) * (1 - 0.16));
      } else if (this.active360Index >= this.dom.$scroll360Items.length - 6) {
        opacity = 1 - ((this.active360Index - (this.dom.$scroll360Items.length - 6)) / 6);
      } else {
        // do nothing
      }
      this.dom.$overplay.css('opacity', opacity);
      this.showContent360();

    } else {
      this.$el.removeClass(`${this.classes.start360Scroll} ${this.classes.showMainBanner}`);
      this.dom.$overplay.css('opacity', '');
    }

  }

  setShowMainNav(value = false) {
    if (this.hasScroll360) {
      window.showMainNav = value;
    }
  }

  setPinItem() {
    const pinWidth = this.winScrollTop - this.startPin;
    if (this.winScrollTop > this.startPin) {
      if (pinWidth <= this.scrollWidthPin) {
        this.dom.$bodyHtml.removeClass(this.classes.done360Scroll);
        this.pinWidthTimBanner = pinWidth;
        this.setShowMainNav(false);
        if (isDesktop()) {
          this.dom.$mainContent.css('transform', `translateY(${pinWidth}px)`);
        }
      } else {
        if (isDesktop()) {
          this.dom.$mainContent.css('transform', `translateY(${this.scrollWidthPin}px)`);
        }
        this.pinWidthTimBanner = this.scrollWidthPin;
        this.dom.$bodyHtml.addClass(this.classes.done360Scroll);
        this.setShowMainNav(true);
      }
      this.dom.$mainContent.attr('data-pin', this.pinWidthTimBanner);
    } else {
      this.pinWidthTimBanner = 0;
      this.setShowMainNav(true);
    }
    window.mainPin = this.pinWidthTimBanner;
  }

  setMarginTop() {
    let heightSubMenu = this.dom.$subNav.length ? this.dom.$subNav.innerHeight() : 0;
    if (!isDesktop()) {
      heightSubMenu = this.dom.$subNav.length ? this.dom.$subNav.find('.group-content-top').innerHeight() : 0;
    }
    if (this.heightSubMenu !== heightSubMenu || this.windowWidth !== $(window).width()) {
      this.dom.$wrapper.css(this.text.marginTop, '');
      this.heightSubMenu = heightSubMenu;
      this.windowWidth = $(window).width();
      this.dom.$wrapper.css(this.text.marginTop, -(this.dom.$wrapper.offset().top - parseFloat(this.dom.$wrapper.css(this.text.marginTop), 10)));
    }
  }

  setHeight() {
    this.dom.$locoScrollMain.css('height', '');
    if (!$('.space-pin').length) {
      this.dom.$mainContent.append(`<div class="space-pin down_xl:hidden" style="height: ${this.scrollWidthPin}px"></div>`);
      this.dom.$locoScrollMain.append(`<div class="space-pin xl:hidden" style="height: ${this.scrollWidthPin}px"></div>`);
    }
  }

  scrollActive() {
    if (this.winScrollTop >= 16 && !this.$el.hasClass('no-scroll-ani')) {
      this.$el.addClass(this.classes.scrollAni);
      // preload image 360 rotate
      this.rotate360s.forEach((rotate360) => {
        if (!rotate360.item.preloadImage) {
          rotate360.item.preloadFirstImage();
        }
      });

      if (!this.hasScroll360) {
        this.$el.addClass(this.classes.showMainBanner);
        this.runRotate360();
        this.runMarzipano();
        window.showMainNav = true;
      } else {
        window.showMainNav = false;
      }
    } else {
      if (this.dom.$body.hasClass(this.classes.firstTabActive)) {
        this.$el.removeClass(this.classes.scrollAni);
        this.dom.$bodyHtml.removeClass(this.classes.showScroll);
        setTimeout(() => {
          this.$el.removeClass(this.classes.showMainBanner);
        }, 100);
      }

      if (!this.hasScroll360) {
        this.$el.removeClass(this.classes.showMainBanner);
      }
      window.showMainNav = true;
    }
    this.checkActive360();
  }

  checkActive360() {
    if (!this.hasScroll360) {
      if (this.winScrollTop >= 1) {
        this.$el.addClass(this.classes.showMainBanner);
        this.runRotate360();
        this.runMarzipano();
      } else {
        this.$el.removeClass(this.classes.showMainBanner);
      }
    }
  }

  changeColorModel() {
    const $jsWrapColor = this.dom.$wrapper.find('.js-price-wrap');
    const $colorEle = $jsWrapColor.find(this.elementClasses.jsColorRadio);
    const colorSelection = new ColorSelection($jsWrapColor);
    colorSelection.changeColorEvent($colorEle);
    // active first color radio when init
    $jsWrapColor.each((_index, wrapElm) => {
      $(wrapElm).find(this.elementClasses.jsColorRadio).eq(0).prop('checked', true);
    });
  }

  setPositionForColorName() {
    const $jsWrapColor = this.dom.$wrapper.find('.js-price-wrap');
    $jsWrapColor.each((_index, wrapElm) => {
      const $wrapElm = $(wrapElm);
      const $colorBg = $wrapElm.find(this.elementClasses.bgColor);
      const $colorName = $wrapElm.find('.js-color-name');
      $colorBg.each((_i2, el) => {
        const $el = $(el);
        if ($el.find('input:checked').length) {
          if (!isTablet()) {
            setPositionColorName($wrapElm.get(0), $el.get(0), $colorName.get(0));
          } else {
            $colorName.css({ transform: '' });
          }
        }
      });
    });
  }

  checkBrightnessColor() {
    const $colorBgImage = this.dom.$wrapper.find('.fake-color-trim').find(this.elementClasses.bgColor).find('img');
    $colorBgImage.each((_i2, el) => {
      const $el = $(el);
      const $parentColorWrap = $el.closest(this.elementClasses.bgColor);
      if (!$parentColorWrap.hasClass(brightCheckedClass) || !($parentColorWrap.hasClass('dark') && $parentColorWrap.hasClass('light'))) {
        const brightness = checkImageBrightness(el);
        $parentColorWrap.addClass(brightness);
      }
    });
  }
}
